import { createClient } from '@sanity/client'

// Sanity.io client configuration
// Note: Schemas are managed elsewhere, we only use the client for queries/mutations
export const client = createClient({
  projectId: import.meta.env.VITE_SANITY_PROJECT_ID || '',
  dataset: import.meta.env.VITE_SANITY_DATASET || 'production',
  useCdn: true, // Use CDN for faster reads
  apiVersion: '2024-01-01', // Use current date (YYYY-MM-DD) for latest API
  token: import.meta.env.VITE_SANITY_TOKEN, // Optional: for authenticated requests
})

// Non-CDN client for fresh data reads (e.g., after updates)
// This bypasses CDN caching to ensure we get the latest data
export const clientNoCdn = createClient({
  projectId: import.meta.env.VITE_SANITY_PROJECT_ID || '',
  dataset: import.meta.env.VITE_SANITY_DATASET || 'production',
  useCdn: false, // No CDN - always fetch fresh data
  apiVersion: '2024-01-01',
  token: import.meta.env.VITE_SANITY_TOKEN,
})

// Helper function to check if Sanity is configured
export const isSanityConfigured = (): boolean => {
  return !!(
    import.meta.env.VITE_SANITY_PROJECT_ID &&
    import.meta.env.VITE_SANITY_DATASET
  )
}
